import { sections } from "../constants/Sections.ts";
import '../styles/Home.css';

export const Home = () => {
    return (
        <div className="about_nsw generic_page">
            <h2 class="main_paragraph">NeoSurfWaves reviendra en ligne sous peu.</h2>
        </div>
    )
}